import { UndoStackContextType } from './undoStack.types';

import { UserDesignOperation } from '~/core/enums';

export const undoStackInitialValue: UndoStackContextType = {
  pushToUndoStack: () => undefined,
  pullFromUndoStack: () => undefined,
  clearUndoStack: () => undefined,
  shapesStack: [],
  undoIndex: undefined,
  maxUndoIndex: 0,
};

export const cutoutOperations = [
  UserDesignOperation.MODIFY_FAUCET,
  UserDesignOperation.MODIFY_ELECTRICAL_CUTOUT,
];

export const cookingAppliancesOperations = [
  UserDesignOperation.MODIFY_COOKTOP,
  UserDesignOperation.MODIFY_RANGE,
];

export const appliancesOperations = [
  UserDesignOperation.MODIFY_SINK,
  ...cookingAppliancesOperations,
  ...cutoutOperations,
];
